import { HttpParams } from "@angular/common/http";
import { Component, OnDestroy, OnInit, SimpleChanges } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";
import { MatRadioChange } from "@angular/material/radio";
import { Observable } from "rxjs";
import { FeaturesBaseComponent } from "src/app/features-common/components/features-base.component";
import Swal from "sweetalert2";
import { WalletService } from "../wallet.service";
import { Router } from '@angular/router';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { SortOrderPipe } from "src/app/framework/pipes/sort-order/sort-order.pipe";

@Component({
  selector: 'app-manage-retailer-funds',
  templateUrl: './manage-retailer-funds.component.html', 
  styleUrls: ['./manage-retailer-funds.component.scss'],
})
export class ManageRetailerFundsComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {
  retailerList: any[] = [];
  accountNumber = new FormControl();
  manageRetailerFundsForm: FormGroup;
  filteredOptions: any[] = [];
  retailerAccountSummary: any;
  //filteredOptions: Observable<any[]>[] = [];
  retailerChecked: boolean = false;
  isAddFunds: boolean = true;
  isRemoveFunds: boolean;
  retailerRadioControl = new FormControl('retailer');
  salesRepList: any;
  filteredSalesrepOptions: any[] = [];
  numberMask = createNumberMask({
    prefix: '$ ',
    suffix: '',
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol :',',
    allowDecimal :true,
    allowNegative : true,
  })
  filteredOptionsbyaccount: any[];
  ismoreFund: boolean = false;

  constructor(private fb: FormBuilder, private walletService: WalletService, private router: Router,private sortPipe: SortOrderPipe) {
    super();
    //
    this.initForm();
  }

  onAddFunds() {
    this.isRemoveFunds = false;
    this.isAddFunds = true;
    this.manageRetailerFundsForm.reset();
    this.clearForm(); 
    this.retailerRadioControl.setValue('retailer');
    this.getAllRetailersList()
    this.getSalesRepsList();
    this.onAutoSelectChanges()
  }
  onRemoveFunds() {
    this.isRemoveFunds = true;
    this.isAddFunds = false;
    this.manageRetailerFundsForm.reset();
    this.clearForm();
    this.retailerRadioControl.setValue('retailer');
    this.getAllRetailersList()
    this.getSalesRepsList();
    this.onAutoSelectChanges()
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.getAllRetailersList();
    this.getSalesRepsList();
    this.onAutoSelectChanges();
  }

  getAllRetailersList() {
    this.walletService.getSlaesRepRetailerList().subscribe((res) => {
      let resData: any = res;
      if (resData.httpcode == 200) {
       
        this.retailerList = resData.data;
        this.filteredOptions = this.retailerList;
       
        this.filteredOptionsbyaccount = this.retailerList;//__data2.sort((a, b) => (a.retailerAccountNum > b.retailerAccountNum) ? 1 : -1);
       
      }
    });
  }

  getSalesRepsList() {
    this.walletService.getSlaesRepList().subscribe((res) => {
      let resData: any = res;
      if (resData.httpcode == 200) {
       
        this.salesRepList = resData.data;
        this.filteredSalesrepOptions = this.salesRepList;
      }
    });
  }

  onAutoSelectChanges() {
    this.manageRetailerFundsForm.get("retailerName").valueChanges.subscribe((res) => {
      this.retailerRadioControl.setValue('retailer');
      let retailerName: string;
      if (res?.retailerName != null && res?.retailerName) {
        retailerName = res.retailerName
      }
      else {
        retailerName = res
      }
      // this.addRemoveFundForm.get("accountNumber").setValue('');
      this.filteredOptions = this.retailerList;
      this.retailerChecked = true;
      this.filteredOptions = res
        ? this._filterRetailerName(retailerName)
        : this.retailerList.slice();
    });


    this.manageRetailerFundsForm
      .get("accountNumber")
      .valueChanges.
      subscribe((res) => {
        this.retailerRadioControl.setValue('retailer');
        let retailerAccountNum: string;
        if (res?.retailerAccountNum) {
          retailerAccountNum = res.retailerAccountNum
        }
        else {
          retailerAccountNum = res
        }
        this.filteredOptionsbyaccount = this.retailerList;
        this.filteredOptionsbyaccount = res
          ? this._filterAccountNumber(retailerAccountNum)
          : this.retailerList.slice();
      });

    this.manageRetailerFundsForm
      .get("salesRepName")
      .valueChanges.
      subscribe((res) => {
        this.retailerRadioControl.setValue('salesRep');
        let salesRepName: string;
        if (res?.salesRepName && res?.salesRepName) {
          salesRepName = res.salesRepName
        }
        else {
          salesRepName = res
        }
        this.filteredSalesrepOptions = this.salesRepList;
       
        this.filteredSalesrepOptions = res
          ? this._filterSalesRepName(salesRepName)
          : this.salesRepList.slice();
      });

  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
  getSelected(event) {
   
  }
  retailerDetailsList: any = {};
  retailerDetails: any = {};

  selectedRetailerDetails(data) {
    
    this.retailerRadioControl.setValue('retailer')
    this.manageRetailerFundsForm.get('salesRepName').setValue('')
    this.walletService
      .getallRetailerDetailsById(data.option.value['retailerDetails'].retailerId)
      .subscribe((res) => {
        let resData: any = res;
        if (resData.httpcode == 200 && res.responseCodes.find(x => x == "TILA_101")) {
          this.retailerDetailsList = resData.data;
          
          this.retailerDetails = resData.data.retailerDetails;
          this.retailerAccountSummary = resData.data.retailerAccountSummary;
          
          this.manageRetailerFundsForm.patchValue({
            retailerType: this.retailerDetails.retailerType,
            otpMobileNumber: this.retailerDetails.otpMobileNumber,
            businessName: this.retailerDetails.businessName,
            dbaName: this.retailerDetails.dbaName,
            address1: this.retailerDetails.address1,
            currentAmount: this.retailerAccountSummary.currentAmount,
            accountNumber: this.retailerDetailsList.retailerAccounts,
          });
        }
      });
  }

  selectedRetailerAcountDetails(data){
    
    this.retailerRadioControl.setValue('retailer')
    this.manageRetailerFundsForm.get('salesRepName').setValue('')
    this.manageRetailerFundsForm.get('retailerName').setValue('')
    this.walletService
      .getallRetailerDetailsById(data.option.value['retailerDetails'].retailerId)
      .subscribe((res) => {
        let resData: any = res;
        if (resData.httpcode == 200 && res.responseCodes.find(x => x == "TILA_101")) {
          this.retailerDetailsList = resData.data;
          
          this.retailerDetails = resData.data.retailerDetails;
          this.retailerAccountSummary = resData.data.retailerAccountSummary;
          

          let _retailerDetails: any = [];
          this.retailerDetailsList.retailerDetails.businessName
          _retailerDetails['retailerName'] = this.retailerDetailsList.retailerDetails.businessName;
          this.manageRetailerFundsForm.patchValue({
            retailerName: _retailerDetails,
            retailerType: this.retailerDetails.retailerType,
            otpMobileNumber: this.retailerDetails.otpMobileNumber,
            businessName: this.retailerDetails.businessName,
            dbaName: this.retailerDetails.dbaName,
            address1: this.retailerDetails.address1,
            currentAmount: this.retailerAccountSummary.currentAmount,
          });
        }
      });
  }

  selectedSalesRepDetails(data: MatAutocompleteSelectedEvent) {
    
    this.manageRetailerFundsForm.get('retailerName').setValue('')
    this.manageRetailerFundsForm.get('accountNumber').setValue('')
    this.retailerRadioControl.setValue('salesRep')
    this.walletService
      .getSalesRepDetailsById(data.option.value?.userId)
      .subscribe((res) => {
        let resData: any = res;
        if (resData.httpcode == 200 && res.responseCodes.find(x => x == "TILA_101") ) {
          this.retailerDetailsList = resData.data;
          
          this.retailerDetails = resData.data.userDetails;
          this.retailerAccountSummary = resData.data.retailerAccountSummary;
          this.manageRetailerFundsForm.patchValue({
            retailerType: this.retailerDetails.retailerType,
            otpMobileNumber: this.retailerDetails.phoneNumber,
            businessName: this.retailerDetails.displayName,
            dbaName: this.retailerDetails.displayName,
            address1: this.retailerDetails.address1,
            currentAmount: resData.data.salesRepWallet.balance,
            amount: '',
            newBalance:'',
          });
        }
      })
  }
  getOptionretailerName(option) {
    //alert("Hello")
    if (option != null && option != undefined) {
      return option.retailerName;
    }
  }

  getOptionSalesrepName(option) {
    if (option != null && option != undefined) {
      return option.name;
    }
  }

  initForm = () => {
    this.manageRetailerFundsForm = this.fb.group({
      retailerRadio: this.retailerRadioControl,
      retailerName: [""],
      retailerType: [""],
      otpMobileNumber: [""],
      businessName: [""],
      salesRepName: [''],
      dbaName: [""],
      address1: [""],
      currentAmount: ["", [Validators.required]],
      amount: ["", [Validators.required,]],
      newBalance: ["", [Validators.required,]],
      accountNumber: [""],
    }, {
      validator: this.priceValidation("currentAmount", "amount"),
    });
  };

  // on toggle radio buttons
  selectedAccountType(e: MatRadioChange) {
    let selectedAccountType: any = e.value;
    if (e.value == 'salesRep') {
      this.manageRetailerFundsForm.reset();
      this.clearForm();
      this.retailerRadioControl.setValue('salesRep');
      this.onAutoSelectChanges(); 

      //this.manageRetailerFundsForm.get("retailerName").setValue('');
      //this.manageRetailerFundsForm.get("accountNumber").setValue('');
      //this.manageRetailerFundsForm.reset();
      
    } else
      if (e.value == 'retailer') {
        this.manageRetailerFundsForm.reset();
        this.initForm();
        this.retailerRadioControl.setValue('retailer');
        this.onAutoSelectChanges();

        //this.manageRetailerFundsForm.get("salesRepName").setValue('');
        //this.manageRetailerFundsForm.reset();
      }
    this.manageRetailerFundsForm.get("retailerRadio").setValue(selectedAccountType);
  }


  // On new ammount entry
  onAmountChange(e) {
    let amount = e;
    amount = amount.replace('$','').replace(',','').replace(' ','');
    let totalAmount: number;
    if (this.isRemoveFunds == true) {
     
      let currentvalue = this.manageRetailerFundsForm.get("currentAmount").value
      totalAmount = Number(currentvalue) - Number(amount);
    }
    if (this.isAddFunds == true) {
     
     
      let currentvalue = this.manageRetailerFundsForm.get("currentAmount").value
      totalAmount = Number(amount) +
      Number(currentvalue);
    }
    this.manageRetailerFundsForm.patchValue({
      newBalance: totalAmount.toFixed(2),
    });

  }

  getOptionText(option) {
    if (option != null && option != undefined) {
      return option.retailerAccountNum;
    }
    return
  }

  selectedclient(event) {
    
  }

  private _filterAccountNumber(value: string) {
    const filterValue = value.toLowerCase();
    return this.retailerList.filter(
      (obj) => obj.retailerAccountNum.toLowerCase().includes(filterValue)
    );
  }

  private _filterRetailerName(value: string) {
   
    const filterValue = value.replace(/\s/g, "").toLowerCase();
    return this.filteredOptions.filter(
      (obj) => obj.retailerName.replace(/\s/g, "").toLowerCase().includes(filterValue)
    );
  }

  private _filterSalesRepName(value: string) {
   
    const filterValue = value.replace(/\s/g, "").toLowerCase();
    return this.filteredSalesrepOptions.filter(
      (obj) => obj.name.replace(/\s/g, "").toLowerCase().includes(filterValue)

    );
  }


  get f() {
    return this.manageRetailerFundsForm.controls;
  }

  onManageFundsSubmit = () => {
    //retailerRadio
    if (this.retailerRadioControl.value == 'retailer') {
      let httpParams = new HttpParams()
        .set("amount", this.manageRetailerFundsForm.get("amount").value.replace('$','').replace(',','').replace(' ',''))
        .set(
          "retailer_account_id",
          this.retailerDetailsList.retailerAccounts.retailerAccountId
        )
        .set(
          "salesrep_account_id",
          this.retailerDetailsList.retailerSalesRepAssignment.userId
        );
      if (this.isAddFunds) {  
        this.walletService.addReatilerAmount(httpParams).subscribe(res => {
         
          if(res.httpcode == 200 && res.responseCodes.find(x => x == "TILA_110") || res.responseStatus == 'Success'){
            //this.clearForm();
            //this.retailerRadioControl.setValue('retailer');
            this.manageRetailerFundsForm.reset();
            this.clearForm();
            
            this.retailerRadioControl.setValue('retailer');
            this.toastrService.success('Funds added successfully!', 'Success', {
              timeOut: 3000,
            });
            this.reloadComponent();
          }
        });
        return
      }
      if (this.isRemoveFunds) {
        this.walletService.removeReatilerAmount(httpParams).subscribe((res) => {
          if (res['httpcode'] == 200) {
            //this.clearForm();
            //this.retailerRadioControl.setValue('retailer');
            this.manageRetailerFundsForm.reset();
            this.clearForm();
            this.retailerRadioControl.setValue('retailer');
            this.toastrService.success('Funds removed successfully!', 'Success', {
              timeOut: 3000,
            });
            this.reloadComponent();
          }
        });
        return
      }
      return
    } else if (this.retailerRadioControl.value == 'salesRep') {
      
      let formData: any = {
        "amount": this.manageRetailerFundsForm.get('amount').value.replace('$','').replace(',','').replace(' ',''),
        "salesrepAccountNumber": this.retailerDetailsList.accountNumber
      }

      if (this.isAddFunds) {
        this.walletService.addSalesRepAmount(formData).subscribe((res) => {
          if (res['httpcode'] == 200) {
            
            //this.manageRetailerFundsForm.reset();
            this.clearForm();
            

            this.retailerRadioControl.setValue('salesRep');
            this.toastrService.success('Funds Added successfully!!!!', 'Success', {
              timeOut: 3000,
            });
            this.reloadComponent();
            
          }return;
        });
        return
      }
      if (this.isRemoveFunds) {
        this.walletService.removeSalesRepAmount(formData).subscribe((res) => {
          if (res['httpcode'] == 200) {
            this.manageRetailerFundsForm.reset();
            this.clearForm();
            this.retailerRadioControl.setValue('salesRep');
            this.toastrService.success('Funds removed successfully!', 'Success', {
              timeOut: 3000,
            });
            this.reloadComponent();
          }
        });
        return
      }
    }
  }

  clearForm() {
   this.initForm();
   this.manageRetailerFundsForm.controls['amount'].clearValidators()
   this.manageRetailerFundsForm.controls['amount'].updateValueAndValidity();
   this.manageRetailerFundsForm.controls['currentAmount'].clearValidators()
   this.manageRetailerFundsForm.controls['currentAmount'].updateValueAndValidity();
   this.manageRetailerFundsForm.controls['newBalance'].clearValidators()
   this.manageRetailerFundsForm.controls['newBalance'].updateValueAndValidity();

  }






  onCancel() {
    this.manageRetailerFundsForm.reset();
    this.clearForm();
    this.retailerRadioControl.setValue('retailer');

    //window.location.reload();
    
  }
  priceValidation(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors.mustMatch) {

        return;
      }
      let totalAmount: number;
      if (this.isAddFunds) {
        totalAmount = Number(control.value) + Number(matchingControl.value);
      }
      if (this.isRemoveFunds) {
        totalAmount = Number(control.value) - Number(matchingControl.value);
      }
      // set error on matchingControl if validation fails
      if (totalAmount < 0) {
        matchingControl.setErrors({ mustMatch: true });

      } else {
        matchingControl.setErrors(null);
      }

    };
  }
  checkSubmitDisplayed() {
    let __amount = this.manageRetailerFundsForm.get("amount").value.replace('$','').replace(',','').replace(' ','')
    if(this.isRemoveFunds && (this.manageRetailerFundsForm.get("currentAmount").value < __amount)){
      this.ismoreFund = false;
      this.toastrService.error('Amount can not be more than Available Credit Balance','Validation', {
        timeOut: 3000,
      });
      return true;
    }
    return !(this.manageRetailerFundsForm.valid && !this.manageRetailerFundsForm.pristine); 
  }

  reloadComponent() {
    let currentUrl = this.router.url;
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([currentUrl]);
    }
 
}